import { CapoPlugin } from "/home/runner/work/certificates-app/certificates-app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];